"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4616],{

/***/ 8081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96098);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const fallbackImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
const Image = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    src,
    height,
    objectFit,
    width,
    alt,
    onClick,
    borderRadius,
    thumbnail,
    hover,
    decoding = "async",
    className,
    lazy = true,
    pngSrc
  } = _a, others = __objRest(_a, [
    "src",
    "height",
    "objectFit",
    "width",
    "alt",
    "onClick",
    "borderRadius",
    "thumbnail",
    "hover",
    "decoding",
    "className",
    "lazy",
    "pngSrc"
  ]);
  const imgElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, __spreadValues({
    ref,
    objectFit,
    src: src || fallbackImage,
    loading: lazy ? "lazy" : "eager",
    hover,
    height,
    decoding,
    alt
  }, others));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    height,
    width,
    onClick,
    borderRadius,
    thumbnail,
    className
  }, pngSrc ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: src,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: pngSrc,
    type: "image/png"
  }), imgElement) : imgElement);
});
Image.displayName = "Image";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ onClick, borderRadius, height, thumbnail, width }) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? "cursor: pointer;" : ""}
  ${borderRadius ? `border-radius: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(borderRadius)};` : ""}
  ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)};` : ""}
  ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(width)};` : ""}
  ${thumbnail ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;` : ""}
`);
const StyledImage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .Z.img(({ hover, height, objectFit }) => `
  width: 100%;
  height: ${height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)}` : "auto"};
  ${objectFit ? `object-fit: ${objectFit}` : ""};
  transition: transform 0.3s;
  &:hover {
    ${hover === "zoom" ? "transform: scale(1.05)" : ""};
  };
`);




/***/ }),

/***/ 98992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40062);



function useModal() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ModalStateContext */ .s);
  if (!context) {
    throw new Error("useModal must be inside a ModalStateContext with a state value");
  }
  return context;
}




/***/ }),

/***/ 66349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63103);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69168);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title), link && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .RightOutlined */ .g, {
    color: link.color
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);




/***/ }),

/***/ 34567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8081);
/* harmony import */ var _helpers_image_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58754);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { src, googleImageParams, link, tracking } = _a, rest = __objRest(_a, ["src", "googleImageParams", "link", "tracking"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, __spreadProps(__spreadValues(__spreadValues({}, tracking), rest), {
    src: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getImageUrlFromGoogleUserContent */ .N)(src, __spreadValues({
      format: "webp"
    }, googleImageParams)),
    pngSrc: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getImageUrlFromGoogleUserContent */ .N)(src, __spreadValues({
      format: "png"
    }, googleImageParams))
  })));
};




/***/ }),

/***/ 11153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ JustForYou; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39298);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17016);
/* harmony import */ var _ProductGrid_ProductGrid_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81142);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68481);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66349);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const JustForYou = (_a) => {
  var _b = _a, {
    header,
    products,
    productsPerRow,
    pagination
  } = _b, rest = __objRest(_b, [
    "header",
    "products",
    "productsPerRow",
    "pagination"
  ]);
  if (!products || !products.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_1__/* .BlockHeader */ .t, __spreadProps(__spreadValues({}, header), {
    title: header.title || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_2__.t)("S\u1EA3n ph\u1EA9m d\xE0nh cho b\u1EA1n")
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductGrid_ProductGrid_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ProductGrid */ .e, {
    products,
    productsPerRow: productsPerRow || 5,
    regionName: "forYouListProduct"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .t, __spreadValues({}, pagination)));
};
JustForYou.displayName = "JustForYou";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div`
  background: white;
  border-radius: 0.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.s16};
`;




/***/ }),

/***/ 58754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ constructGoogleImageParams; },
/* harmony export */   "N": function() { return /* binding */ getImageUrlFromGoogleUserContent; }
/* harmony export */ });
const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const params = [];
  Object.entries(config).forEach(([key, value]) => {
    if (!value)
      return;
    if (key === "format") {
      params.push(imgAttributeMapping[value]);
      return;
    }
    if (key === "size" && value) {
      params.push(`${imgAttributeMapping[key]}0`);
      return;
    }
    if (imgAttributeMapping[key]) {
      if (typeof value === "boolean") {
        if (value) {
          params.push(`${imgAttributeMapping[key]}`);
          return;
        }
        return;
      }
      params.push(`${imgAttributeMapping[key]}${value}`);
    }
  });
  return params.length > 0 ? `${baseUrl}=${params.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com"))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};




/***/ }),

/***/ 8505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DiscoveryRecommendedProducts": function() { return /* binding */ DiscoveryRecommendedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90450);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11153);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70538);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55140);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5899);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84249);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const HEADER_HEIGHT = 56;
const DiscoveryRecommendedProducts = (param)=>{
    let { paramsObject , title , actionLink , itemsPerPage , serverProducts =[]  } = param;
    const { convertNewProductCard  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useNewProductCard */ .A)();
    const { terminal , location  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { 0: pageNumber , 1: setPageNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const PAGE_SIZE = itemsPerPage || constants_index__WEBPACK_IMPORTED_MODULE_4__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl;
    const { result , isLoading  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useDiscoverySearch */ .b9)(_objectSpreadProps(_objectSpread({}, paramsObject), {
        terminalCode: terminal,
        pageNumber: pageNumber,
        itemsPerPage: PAGE_SIZE,
        location
    }));
    const top = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const newProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        var ref;
        return ((result === null || result === void 0 ? void 0 : (ref = result.products) === null || ref === void 0 ? void 0 : ref.length) ? result.products : serverProducts).map((product)=>convertNewProductCard(product));
    }, [
        result
    ]);
    const handlePageChanged = (page)=>{
        if (top && top.current) {
            const element = top.current;
            window.scrollTo({
                left: 0,
                top: getElementOffset(element).top - HEADER_HEIGHT - 30
            });
        }
        setPageNumber(page);
    };
    if (!newProducts.length) {
        return isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .PreLoad */ .b, {
            height: 1000,
            isLoading: isLoading
        }) : null;
    }
    const totalItems = result.pagination.totalItems;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: top,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .JustForYou */ .L, {
            header: {
                title: title,
                link: totalItems > PAGE_SIZE && actionLink || undefined
            },
            products: newProducts,
            productsPerRow: 5,
            pagination: {
                totalRecords: totalItems,
                currentPage: pageNumber,
                pageLimit: PAGE_SIZE,
                pageNeighbor: 2,
                onPageChange: handlePageChanged,
                color: "primary500"
            }
        })
    });
};
//get element offset relative to the document
const getElementOffset = (elem)=>{
    const box = elem.getBoundingClientRect();
    const body = document.body;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return {
        top,
        left
    };
};


/***/ }),

/***/ 84249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fl": function() { return /* binding */ LIMIT_ITEM_PER_PAGE_PRODUCT_LIST; },
/* harmony export */   "Hj": function() { return /* binding */ MASAN_SAN_PHAM_CAT_CODE; },
/* harmony export */   "N2": function() { return /* binding */ MASAN_VO_BINH_CAT_CODE; },
/* harmony export */   "_V": function() { return /* binding */ RECENTLY_VIEWED_PRODUCTS_KEY; },
/* harmony export */   "z3": function() { return /* binding */ TENANT_LIMIT_SEARCH_CAT; }
/* harmony export */ });
const MASAN_VO_BINH_CAT_CODE = "mch_vo_binh";
const MASAN_SAN_PHAM_CAT_CODE = [
    "mch_san_pham",
    "mch_qua_tang"
];
const LIMIT_ITEM_PER_PAGE_PRODUCT_LIST = 20;
const TENANT_LIMIT_SEARCH_CAT = {
    "masan-dealer": MASAN_SAN_PHAM_CAT_CODE
};
const RECENTLY_VIEWED_PRODUCTS_KEY = "viewed-products";


/***/ })

}]);